export const MIN_AGE = 18;
export const MAX_AGE = 80;

export const apiGatewayBase = window.topContext.config.getEndpointConfig().apiGatewayBase;
export const wso2host = window.topContext.config.getEndpointConfig().wso2host;
export const environment = window.topContext.config.getSiteConfig().environment;

export const wso2header = {
    'x-top-appname': 'onsa-flow-template',
    'x-top-host': wso2host
};

export const extendedWso2header = {
    'x-top-appname': 'onsa-flow-template',
    'x-top-host': wso2host,
    'x-top-dscm': environment,
    'x-top-port': '80',
    'x-top-brand': 'TD'
};

export const coverageTextsURL = 'https://www.topdanmark.dk/rest/coverage/';

export const deductibleYoungDriver = '8.758';
